module.exports = __webpack_public_path__ + "static/media/edit_profile.1e09902a.svg";